import { DashboardWidgetPreference } from '../system'

// s: a quarter of the row (a single indicator), m: half (lists), l: the whole row (charts)
export type DashboardWidgetSize = DashboardWidgetPreference['size']

// Data a card needs: it is only loaded when a visible card needs it
export enum DashboardDataSource {
    SALES = 'sales',
    OPERATIONS = 'operations',
    FINANCE = 'finance',
    WAREHOUSE = 'warehouse',
    LOGISTICS = 'logistics',
    PURCHASES = 'purchases'
}

// Which operations the cards of a role count: the user's own (sales), the current branch's (warehouse,
// logistics) or the whole company's
export enum DashboardScope {
    MINE = 'mine',
    BRANCH = 'branch',
    COMPANY = 'company'
}

export type DashboardWidgetDefinition<T> = {
    id: string
    title: string
    description: string
    defaultSize: DashboardWidgetSize
    sources: DashboardDataSource[]
    // Screen the card links to: a role that can't open it (it isn't in its menu) doesn't get the card
    linkPath?: string
    render: (data: T) => JSX.Element
}

// A card of a role: shown by default or only available to add. w / h override its default size and x / y fix its
// place in the default layout (without them it's placed after the previous card)
export type RoleDashboardWidget<T> = {
    widget: DashboardWidgetDefinition<T>
    visible: boolean
    x?: number
    y?: number
    w?: number
    h?: number
}

// Wide screen grid: 12 columns and rows of DASHBOARD_ROW_HEIGHT px
export const DASHBOARD_COLUMNS = 12
export const DASHBOARD_ROW_HEIGHT = 30

// Default and minimum place each size takes in the grid (a row is 30px plus a 12px gap: 3 rows ≈ 114px)
export const widgetSizeGrid: Record<DashboardWidgetSize, { w: number, h: number, minW: number, minH: number }> = {
    s: { w: 3, h: 3, minW: 2, minH: 3 },
    m: { w: 6, h: 6, minW: 3, minH: 4 },
    l: { w: 12, h: 8, minW: 6, minH: 6 }
}
